module.exports = __webpack_public_path__ + "img/FI.e123c032.jpg";